<template>
 <div id="app">
    <!-- <div class='fullscreenDiv'>
    <div class="center">Under maintenance</div>
    <img ref="splash" alt="reward shuf pick winner" class="loadicon center" src="./assets/hat-logo-transparent.png"> 
    </div> -->
    <Head/>
    <Stats/>
    <Interact/>
    <Rules/>
    <Footer/>
  </div> 
</template>

<script>
import Head from './components/Head.vue'
import Stats from './components/Stats.vue'
import Interact from './components/Interact.vue'
import Rules from './components/Rules.vue'
import Footer from './components/Footer.vue'


export default {
  name: 'app',
  components: {
    Head,
    Stats,
    Interact,
    Rules,
    Footer
  }
}
</script>

<style>

/* poppins-regular - latin */
@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  src: url('./assets/fonts/poppins-v9-latin-regular.eot'); /* IE9 Compat Modes */
  src: local('Poppins Regular'), local('Poppins-Regular'),
       url('./assets/fonts/poppins-v9-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('./assets/fonts/poppins-v9-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
       url('./assets/fonts/poppins-v9-latin-regular.woff') format('woff'), /* Modern Browsers */
       url('./assets/fonts/poppins-v9-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
       url('./assets/fonts/poppins-v9-latin-regular.svg#Poppins') format('svg'); /* Legacy iOS */
}
.loadicon{
    max-width:90%;
    max-height: 400px;
    opacity: 0.2;
    position: absolute;
    z-index: -1;
}
.center {
  font-weight: 900;
  font-size:35px;
  position: fixed; /* or absolute */
  top: 50%;
  left: 50%;
  /* bring your own prefixes */
  transform: translate(-50%, -50%);
}
#app {
 font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
